import React, {useEffect, useState} from "react"
import Tooltip from "rc-tooltip"
import { Link } from "gatsby"

import questionImg from "../../images/new-pricing/question.svg"

import soloTextbgImg from "../../images/new-pricing/solo-text-bg.svg"
import checkboxImg from "../../images/new-pricing/checked.svg"
import buttonArrowImg from "../../images/new-pricing/button-arrow.svg"
import cleanerImg from "../../images/new-pricing/cleaner.svg"
import painterImg from "../../images/new-pricing/painter.svg"
import rightArrowImg from "../../images/new-pricing/right-arrow.svg"
import offerTextImg from "../../images/new-pricing/offer-text.png"

import queryString from "query-string";
import ReactGA from "react-ga";
const CustomToolTip = props => {
  const tooltipStyle = {
    height: "auto",
    width: props.width,
    textAlign: "center",
    verticalAlign: "middle",
  }
  return (
    <Tooltip
      overlayStyle={tooltipStyle}
      placement="top"
      overlay={props.tooltipText}
      trigger={["hover"]}
      arrowContent={<div className="rc-tooltip-arrow-inner" />}
    >
      {props.children}
    </Tooltip>
  )
}

export default function Plans({ activeTab, onlyQbo = false, location = {}, nsip = false, registrationDetails = null, refToken, page, queryParam }) {
  const [referralToken, setReferralToken] = useState("")
  const [isSpecialOfferCode, setSpecialOfferCode] = useState(false);

  const { state = {} } = location;
  useEffect(() => {
    const urlState = queryString.parse(location.search)
    if(urlState.ref_token){
      setReferralToken(urlState.ref_token);
    }
  }, [])

  useEffect(() => {
    if(refToken){
      setReferralToken(refToken)
    }
  }, [refToken])

  const pricingBtnClick = (planName, btn) => {
    ReactGA.event({
      category: `${planName} Pricing Page_Start My Free 30-day Trial`,
      action: `${planName} Pricing Page_Start My Free 30-day Trial`
    });
  }

  const buyNowClick = (planName) => {
    ReactGA.event({
      category: `SS Pricing Page_${planName} Plan_Buy Now`,
      action: `SS Pricing Page_${planName} Plan_Buy Now`
    });
  }

  return (
    <div className={`plans mx-auto flex justify-content-center ${activeTab === 2 && 'mt-260p'}`}>
      {activeTab === 1 ?
        <div className="card1">
          <div className='relative w-full mt-3'>
            <img src={soloTextbgImg} className='mx-auto' />
            <div className='absolute text-24 font-bold solo-text'>
              Solo Plan
            </div>
          </div>
        <div className="heading text-15 justify-content-center text-neutral-3 font-medium w-full">No Existing Software Required</div>
        <div className="content w-full">
          <div className='flex w-full relative border-b border-color mb-8'>
            <img className="pl-12 left-img left-px absolute sm:block hidden" src={cleanerImg}/>
            <div className="flex flex-row w-full items-center  justify-content-center">
              <div className="pb-8">
                <h2 className="text-30 font-bold text-mind mt-0 mb-0 mx-auto">
                  $10
                  <span className="text-xl">
                    /mo
                    <span className="uppercase text-sm text-gray-14 font-medium ml-1">
                      AUD
                    </span>
                  </span>
                </h2>
                <span className="sm:flex items-center t2 text-gray-14 mt-1">
                  <span>Great for anyone with no accounting software</span>
                  <CustomToolTip
                    height="131px"
                    width="211px"
                    tooltipText={
                      <span>
                        If you’re a sole trader and looking to purely manage your bills this is the plan for you!
                        No accounting software needed.
                      </span>
                    }
                  >
                    <div className='icon-img'>
                      <img
                        src={questionImg}
                        className="ml-1"
                        alt="luca"
                        data-parallax='{"x" : -50}'
                      />
                    </div>
                  </CustomToolTip>
                </span>
              </div>
            </div>
            <img className="pr-12 absolute -top-9 right-img sm:block hidden" src={painterImg}/>
            <div className="line mb-8" />
          </div>
          <div className="w-full mx-auto relative">
          <ul className="leading-6 flex flex-col sm:w-6/12 w-auto items-start text-left middle-content__list pl-6 sm:pl-10 mx-2 sm:mx-auto">
            {SOLO_PLAN.map(data =>
                !data.trialText &&
                <li className={`${data.icon} text-neutral-3 flex sm:text-15 text-13`}>
                  <img src={checkboxImg} className='mr-2' />
                  {data.content}
                  {data.tooltip && (
                      <CustomToolTip
                          height={data.tooltipHeight}
                          width={data.tooltipWidth}
                          tooltipText={data.tooltipText}
                      >
                        <img
                            src={questionImg}
                            className="ml-1"
                            alt="luca"
                            data-parallax='{"x" : -50}'
                        />
                      </CustomToolTip>
                  )}
                </li>
            )}
          </ul>
          <div className="bottom-content mx-auto text-center mb-10 mt-5">
            <Link
              onClick={() => pricingBtnClick("Solo Plan", "buy now")}
              to={`/sign-up/?plan=solo${referralToken && `&ref_token=${referralToken}`}${queryParam && '&' + queryParam}`}
              state={{ isTrial: true, plan: "solo", referralToken: referralToken, nsip: nsip, registrationDetails: registrationDetails, isPromoCode: isSpecialOfferCode, page: page }}
            >
              <button className="bg-mind rounded leading-7 text-white capitalize w-7/12">
                Start My Free 30-day Trial
              </button>
            </Link>
            {/*<Link*/}
            {/*    to={`/sign-up/${referralToken && `?ref_token=${referralToken}`}`}*/}
            {/*  state={{ isTrial: true, plan: "solo", price: 0, referralToken: referralToken, nsip: nsip, registrationDetails: registrationDetails}}*/}
            {/*>*/}
            {/*  <button className="bg-white border-brand rounded leading-7 mt-3 capitalize w-full hover:bg-brand hover:text-white">*/}
            {/*    Free Trial*/}
            {/*  </button>*/}
            {/*</Link>*/}
          </div>
          </div>
        </div>
      </div>
      :  <div className='sm:flex card2'>
          <div className="card1">
            <div className='relative w-full mt-3'>
              <img src={soloTextbgImg} className='mx-auto' />
              <div className='absolute text-24 font-bold solo-text'>
                Starter Plan
              </div>
            </div>
            <div className="heading text-15 justify-content-center text-neutral-3 font-medium w-full">Accounting Software Supported</div>
            <div className="content w-full">
              <div className='flex w-full relative border-b border-color mb-8'>
                <div className="flex flex-row w-full items-center  justify-content-center">
                  <div className="pb-8">
                    <h2 className="text-30 font-bold text-mind mt-0 mb-0 mx-auto">
                      FREE
                    </h2>
                    <span className="flex font-medium text-gray-14 mt-1">
                      Best for starting up & exploring
                      <CustomToolTip
                        height="131px"
                        width="211px"
                        tooltipText={
                          <span>
                            If you’re a sole trader and looking to purely send
                            e-invoices & manage your bills this is the plan for you!
                            No accounting software needed.
                          </span>
                        }
                      >
                        <img
                          src={questionImg}
                          className="ml-1"
                          alt="luca"
                          data-parallax='{"x" : -50}'
                        />
                      </CustomToolTip>
                    </span>
                  </div>
                </div>
                <div className="line mb-8" />
              </div>
              <div className="w-full mx-auto relative">
                <div className='flex justify-content-center flex-col'>
                  <ul className="leading-6 flex flex-col w-auto items-start text-left middle-content__list sm:mx-auto mx-5">
                    {STARTER_PLAN.map(data =>
                      !data.trialText &&
                      <li className={`${data.icon} text-neutral-3 flex sm:text-15 text-13`}>
                        <img src={checkboxImg} className='mr-2' />
                        {data.content}
                        {data.tooltip && (
                          <CustomToolTip
                            height={data.tooltipHeight}
                            width={data.tooltipWidth}
                            tooltipText={data.tooltipText}
                          >
                            <img
                              src={questionImg}
                              className="ml-1"
                              alt="luca"
                              data-parallax='{"x" : -50}'
                            />
                          </CustomToolTip>
                        )}
                      </li>
                    )}
                  </ul>
                  <div className="bottom-content mx-auto text-center mb-10 mt-5">
                  <Link
                    onClick={() => buyNowClick("Starter", "buy now")}
                    to={`/sign-up/?plan=starter${referralToken && `?ref_token=${referralToken}`}${queryParam && '&' + queryParam}`}
                    state={{ isTrial: true, plan: "starter", referralToken: referralToken, nsip: nsip, registrationDetails: registrationDetails, isPromoCode: isSpecialOfferCode, page: page }}
                  >
                    <button className="bg-mind rounded leading-7 text-white capitalize w-7/12">
                      Buy Now
                    </button>
                  </Link>
                </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card1">
            <div className='relative w-full mt-3'>
              <img src={soloTextbgImg} className='mx-auto' />
              <div className='absolute text-24 font-bold solo-text'>
                Standard Plan
              </div>
            </div>
            <div className="heading text-15 justify-content-center text-neutral-3 font-medium w-full">Accounting Software Supported</div>
            <div className="content w-full">
              <div className='flex w-full relative border-b border-color mb-8'>
                <div className="flex flex-row w-full items-center  justify-content-center">
                  <div className="pb-8">
                    <h2 className="text-30 font-bold text-mind mt-0 mb-0 mx-auto">
                      $10
                      <span className="text-xl">
                    /mo
                    <span className="uppercase text-sm text-gray-14 font-medium ml-1">
                      AUD
                    </span>
                  </span>
                    </h2>
                    <span className="flex font-medium text-gray-14 mt-1">
                      Everything you need to get fast results
                      <CustomToolTip
                        height="131px"
                        width="211px"
                        tooltipText={
                          <span>
                            If you’re a sole trader and looking to purely send
                            e-invoices & manage your bills this is the plan for you!
                            No accounting software needed.
                          </span>
                        }
                      >
                        <img
                          src={questionImg}
                          className="ml-1"
                          alt="luca"
                          data-parallax='{"x" : -50}'
                        />
                      </CustomToolTip>
                    </span>
                  </div>
                </div>
                <div className="line mb-8" />
              </div>
              <div className="w-full mx-auto relative">
                <div className='flex justify-content-center flex-col'>
                  <ul className="leading-6 flex flex-col w-auto items-start text-left middle-content__list sm:mx-auto mx-5">
                    {STANDARD_PLAN.map(data =>
                      !data.trialText &&
                      <li className={`${data.icon} text-neutral-3 flex sm:text-15 text-13`}>
                        <img src={checkboxImg} className='mr-2' />
                        {data.content}
                        {data.tooltip && (
                          <CustomToolTip
                            height={data.tooltipHeight}
                            width={data.tooltipWidth}
                            tooltipText={data.tooltipText}
                          >
                            <img
                              src={questionImg}
                              className="ml-1"
                              alt="luca"
                              data-parallax='{"x" : -50}'
                            />
                          </CustomToolTip>
                        )}
                      </li>
                    )}
                  </ul>
                  <div className="bottom-content mx-auto text-center mb-10 mt-5">
                  <Link
                    onClick={() => buyNowClick("Standard", "buy now")}
                    to={`/sign-up/?plan=standard${referralToken && `&ref_token=${referralToken}`}${queryParam && '&' + queryParam}`}
                    state={{ isTrial: true, plan: "standard", referralToken: referralToken, nsip: nsip, registrationDetails: registrationDetails, isPromoCode: isSpecialOfferCode, page: page }}
                  >
                    <button className="bg-mind rounded leading-7 text-white capitalize w-7/12">
                      Buy Now
                    </button>
                  </Link>
                </div>
                </div>
              </div>
            </div>
          </div>
        </div>}
    </div>
  )
}

const ADDITIONAL_FEATURE_TOOLTIP_TEXT = (<ul>
  <li>Cash Flow Forecast</li>
  <li>Revenue Forecast</li>
  <li>Debtor/Creditor Reconciliation</li>
  <li>Transactions Amendment Report</li>
</ul>);

export const SOLO_PLAN = [
  {
    content: "LUCA Pay for getting paid and paying bills on time", icon: "checked",
    // tooltip: true,
    tooltip: false,
    // tooltipText:  <span>
    //                 If you work with a Bookkeeper or Accountant you can add them
    //                 to your LUCA Plus platform.
    //               </span>,
    // tooltipHeight: "99px",
    // tooltipWidth: "211px",
    iconImg:'/assets/img/checked.svg'
  },
  {
    content: "Built-in Income Projection", icon: "checked", tooltip: false, iconImg:'/assets/img/checked.svg'
  },
  // {
  //   content: "Send unlimited e-invoices", icon: "checked", tooltip: false, iconImg:'/assets/img/checked.svg'
  // },
  // {
  //   content: "Receive unlimited e-invoices as bills", icon: "checked", tooltip: false, iconImg:'/assets/img/checked.svg'
  // },
  {
    content: "Track full invoices life cycle", icon: "checked", tooltip: false, iconImg:'/assets/img/checked.svg'
  },
  {
    content: "Unlimited historical data", icon: "checked", tooltip: false, iconImg:'/assets/img/checked.svg'
  },
  {
    content: "Earn and refer program", icon: "checked", tooltip: false, iconImg:'/assets/img/checked.svg'
  },
  {
    content: "Customer Payment Behavior Report", icon: "checked", tooltip: false, iconImg:'/assets/img/checked.svg'
  },
  {
    content: "Customer Invoice Risk Assessment", icon: "checked", tooltip: false, iconImg:'/assets/img/checked.svg'
  },
  {
    content: "Mobile App", icon: "checked", tooltip: false, iconImg:'/assets/img/checked.svg'
  },
  // {
  //   content: "Additional features", icon: "unchecked", tooltip: true,
  //   tooltipText: ADDITIONAL_FEATURE_TOOLTIP_TEXT,
  //   tooltipHeight: "127px",
  //   tooltipWidth: "204px",
  //   iconImg:'/assets/img/unchecked.svg'
  // }
];

export const STARTER_PLAN = [
  {
    content: "LUCA Pay for getting paid and paying bills on time", icon: "checked", tooltip: false
  },
  {
    content: "Built-in Income Projection", icon: "checked", tooltip: false
  },
  // {
  //   content: "Send unlimited e-invoices", icon: "checked", tooltip: false
  // },
  // {
  //   content: "Receive 10 e-invoices as bills", icon: "checked", tooltip: false
  // },
  {
    content: "Track full invoices life cycle", icon: "checked", tooltip: false
  },
  {
    content: "Unlimited historical data", icon: "checked", tooltip: false
  },
  {
    content: "Earn and refer program", icon: "checked", tooltip: false
  },
  {
    content: "Customer Payment Behavior Report", icon: "unchecked", tooltip: false,
  },
  {
    content: "Customer Invoice Risk Assessment", icon: "unchecked", tooltip: false,
  },
  {
    content: "Transaction Amendment Report", icon: "unchecked", tooltip: false,
  }
  // {
  //   content: "Additional features", icon: "unchecked", tooltip: true,
  //   tooltipText: ADDITIONAL_FEATURE_TOOLTIP_TEXT,
  //   tooltipHeight: "127px",
  //   tooltipWidth: "204px"
  // }
];

export const STANDARD_PLAN = [
  {
    content: "LUCA Pay for getting paid and paying bills on time", icon: "checked", tooltip: false,
    // tooltipText: <span>
    //                 Enable collaboration amongst your
    //                 team and also with your Accountant
    //                 or Bookkeeper.
    //               </span>,
    // tooltipHeight: "99px",
    // tooltipWidth: "224px"
  },
  {
    content: "Built-in Income Projection", icon: "checked", tooltip: false
  },
  // {
  //   content: "Send unlimited e-invoices", icon: "checked", tooltip: false
  // },
  // {
  //   content: "Receive unlimited e-invoices as bills", icon: "checked", tooltip: false
  // },
  {
    content: "Track full invoices life cycle", icon: "checked", tooltip: false
  },
  {
    content: "Unlimited historical data", icon: "checked", tooltip: false
  },
  {
    content: "Earn and refer program", icon: "checked", tooltip: false
  },
  {
    content: "Customer Payment Behavior Report", icon: "checked", tooltip: false
  },
  {
    content: "Customer Invoice Risk Assessment", icon: "checked", tooltip: false
  },
  {
    content: "Transaction Amendment Report", icon: "checked", tooltip: false
  },
  // {
  //   content: "Additional features", icon: "checked", tooltip: true,
  //   tooltipText: ADDITIONAL_FEATURE_TOOLTIP_TEXT,
  //   tooltipHeight: "127px",
  //   tooltipWidth: "204px"
  // }
];
